var _g;
import * as React from "react";
var SvgChartCheck = function SvgChartCheck(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.998535,17.646484l-5.37207-5.373047l1.646973-1.646973l3.728516,3.728027l6.05957-5.999512l1.647461,1.646484 L10.998535,17.646484z"
  })));
};
export default SvgChartCheck;